// extracted by mini-css-extract-plugin
export default {"unreadBadge":"ExpandedActivityListItem_unreadBadge__En7yc"};